import { request as __request } from '../request/request';
import { OpenAPI } from '../request/open-api';
import { BloodPressureResponseDto } from 'types/types';

export const getPatientBloodPressure = (patientId: string) => {
  return __request<BloodPressureResponseDto[]>(OpenAPI, {
    method: 'GET',
    url: `/action/measures/blood_pressure/by_patient_id/${patientId}`,
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};
